export * from "@repo/backend/config";
export const API_URL =
  process.env.NEXT_PUBLIC_API_URL || "http://localhost:3053/api";
export const UMAMI_DISABLED_KEY = "umami.disabled";

/** If we get less than this number of results for a category, we add more results by using search */
export const MIN_RESULTS_FOR_VERSURI_CATEGORY_TO_SKIP_SEARCH = 3;